import { all, fork } from 'redux-saga/effects';

//Watchers
import {
    watchRequestListPractitioners,
    watchSearchRequestPractitioners,
    watchRequestProfilPractitioner,
    watchRequestFilesPractitioner,
    watchAddFilePractitioner,
    watchUpdatePractitioner,
    watchSynchronisePlatformPractitioner
} from "./practitioners.saga";
import { watchRequestListConsultations,
    watchSearchRequestConsultations,
    watchRequestConsultationsPractitioner,
    watchSearchConsultationPractitioner,
    watchRequestDetailsConsultation,
    watchSearchConsultationPatient,
    watchUnlockConsultation
} from "./consultations.saga";
import {
    watchRequestListPatients,
    watchSearchRequestPatients,
    watchRequestProfilPatient,
    watchRequestConsultationsPatient, watchUpdatePatient
} from "./patients.saga";
import {
    watchRequestGeneralStatistics
} from "./statistics.saga";
import {
    watchResetPasswordUser,
    watchSendAuthenticationCodeUser,
    watchRequestUserCodes
} from "./users.saga";
import {
    watchDeleteLanguage,
    watchRequestListLanguages,
    watchSearchLanguages,
    watchUpdateLanguage
} from "./Languages.saga";
import {watchRequestListSpecialties} from "./specialties.saga";
import {watchRequestListConventions} from "./convention.saga";
import {
    watchRequestPharmacy,
    watchSearchPharmacies,
    watchUpdatePharmacy
} from "./pharmacies.saga"
import {
    watchRequestProviders
} from "./providers.saga";
import {watchCreateSlot, watchPremiumPatient} from "./Premium.saga";

export function* watchAll() {
    yield all([
        /** Practitioners **/
        fork(watchRequestListPractitioners),
        fork(watchSearchRequestPractitioners),
        // Profil Practitioner
        fork(watchRequestProfilPractitioner),
        // Codes de connexion
        fork(watchRequestUserCodes),
        fork(watchSendAuthenticationCodeUser),
        // Consultations Practitioner
        fork(watchRequestConsultationsPractitioner),
        fork(watchSearchConsultationPractitioner),
        //Files
        fork(watchRequestFilesPractitioner),
        fork(watchAddFilePractitioner),
        fork(watchUpdatePractitioner),
        /** Consultations **/
        fork(watchRequestListConsultations),
        fork(watchSearchRequestConsultations),
        fork(watchRequestDetailsConsultation),
        fork(watchUnlockConsultation),
        /** Patients **/
        fork(watchRequestListPatients),
        fork(watchSearchRequestPatients),
        // Profil Patient
        fork(watchRequestProfilPatient),
        fork(watchUpdatePatient),
        // Consultations Patient
        fork(watchSearchConsultationPatient),
        // Consultations Practitioner
        fork(watchRequestConsultationsPatient),
        /** Statistiques **/
        fork(watchRequestGeneralStatistics),
        /** User **/
        fork(watchResetPasswordUser),
        /** Languages **/
        fork(watchRequestListLanguages),
        fork(watchUpdateLanguage),
        fork(watchSearchLanguages),
        fork(watchDeleteLanguage),
        /** Specialties **/
        fork(watchRequestListSpecialties),
        /** Conventions **/
        fork(watchRequestListConventions),
        /** Sync **/
        fork(watchSynchronisePlatformPractitioner),
        /** Pharmacies **/
        fork(watchSearchPharmacies),
        fork(watchUpdatePharmacy),
        fork(watchRequestPharmacy),
        /** Providers **/
        fork(watchRequestProviders),
        /** Premium **/
        fork(watchPremiumPatient),
        fork(watchCreateSlot)
    ]);
}


// WEBPACK FOOTER //
// ./src/sagas/index.js